module.exports = __webpack_public_path__ + "static/media/Image1.0cfa7eda.jpeg";